import { Helpers } from '../../helpers';
import { IEmployee } from '../../interfaces/iemployee';
import { DefaultProjectTeam } from '../default-project-team';
import { ItemRateTableName } from '../item-rate-table-name';
import { Project } from '../project';
import { ProjectEstimate } from '../project-estimate';
import { ProjectTeamMemberAssignment } from '../project-team-member-assignment';
import { ProjectTemplate } from '../project-template';

export class EmployeeBase {
  EmployeeId: number;
  EmployeeUID: string | null;
  AssetTeamSourceText: string | null;
  CompanyCodeChar: string | null;
  CompanyName: string | null;
  CostCenterCode: string | null;
  CostCenterName: string | null;
  EmailAddress: string;
  WorkerType: string | null;
  EmployeeWorkCellPhone: string | null;
  EmployeeWorkPhone: string | null;
  FirstName: string | null;
  FullOrPartTime: string | null;
  JobCode: string | null;
  JobCodeDescription: string | null;
  JobStatus: string | null;
  JobTitle: string | null;
  LastName: string | null;
  MiddleName: string | null;
  OfficeLocationCode: string | null;
  OfficeLocationName: string | null;
  PreferredFirstName: string | null;
  Suffix: string | null;
  SupervisorSourceSystemIdentifier: string | null;
  SourceSystemIdentifier: string | null;
  CompanyCodeNumeric: string | null;
  SysActionUID: string | null;
  SysStartTime: Date;
  SysEndTime: Date;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ProjectTeamMemberAssignments_Employee?: Array<ProjectTeamMemberAssignment> | null;
  DefaultProjectTeams_ProgramManagerEmployee?: Array<DefaultProjectTeam> | null;
  DefaultProjectTeams_ProjectControlAnalystEmployee?: Array<DefaultProjectTeam> | null;
  DefaultProjectTeams_ProjectEngineerEmployee?: Array<DefaultProjectTeam> | null;
  DefaultProjectTeams_ProjectManagerEmployee?: Array<DefaultProjectTeam> | null;
  DefaultProjectTeams_ProjectTechEmployee?: Array<DefaultProjectTeam> | null;
  ItemRateTableNames_Owner?: Array<ItemRateTableName> | null;
  ProjectEstimates_Creator?: Array<ProjectEstimate> | null;
  ProjectEstimates_RecordApprover?: Array<ProjectEstimate> | null;
  Projects_CreatorUser?: Array<Project> | null;
  ProjectTemplates_OwnerEmployee?: Array<ProjectTemplate> | null;

  constructor(item?: IEmployee) {
    if (item) {

      this.EmployeeId = item.EmployeeId;
      this.EmployeeUID = item.EmployeeUID;
      this.AssetTeamSourceText = item.AssetTeamSourceText;
      this.CompanyCodeChar = item.CompanyCodeChar;
      this.CompanyName = item.CompanyName;
      this.CostCenterCode = item.CostCenterCode;
      this.CostCenterName = item.CostCenterName;
      this.EmailAddress = item.EmailAddress;
      this.WorkerType = item.WorkerType;
      this.EmployeeWorkCellPhone = item.EmployeeWorkCellPhone;
      this.EmployeeWorkPhone = item.EmployeeWorkPhone;
      this.FirstName = item.FirstName;
      this.FullOrPartTime = item.FullOrPartTime;
      this.JobCode = item.JobCode;
      this.JobCodeDescription = item.JobCodeDescription;
      this.JobStatus = item.JobStatus;
      this.JobTitle = item.JobTitle;
      this.LastName = item.LastName;
      this.MiddleName = item.MiddleName;
      this.OfficeLocationCode = item.OfficeLocationCode;
      this.OfficeLocationName = item.OfficeLocationName;
      this.PreferredFirstName = item.PreferredFirstName;
      this.Suffix = item.Suffix;
      this.SupervisorSourceSystemIdentifier = item.SupervisorSourceSystemIdentifier;
      this.SourceSystemIdentifier = item.SourceSystemIdentifier;
      this.CompanyCodeNumeric = item.CompanyCodeNumeric;
      this.SysActionUID = item.SysActionUID;
      this.SysStartTime = item.SysStartTime ? new Date(item.SysStartTime) : null;
      this.SysEndTime = item.SysEndTime ? new Date(item.SysEndTime) : null;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.DefaultProjectTeams_ProgramManagerEmployee = Helpers.createClassArray(DefaultProjectTeam, item.DefaultProjectTeams_ProgramManagerEmployee);
      this.DefaultProjectTeams_ProjectControlAnalystEmployee = Helpers.createClassArray(DefaultProjectTeam, item.DefaultProjectTeams_ProjectControlAnalystEmployee);
      this.DefaultProjectTeams_ProjectEngineerEmployee = Helpers.createClassArray(DefaultProjectTeam, item.DefaultProjectTeams_ProjectEngineerEmployee);
      this.DefaultProjectTeams_ProjectManagerEmployee = Helpers.createClassArray(DefaultProjectTeam, item.DefaultProjectTeams_ProjectManagerEmployee);
      this.DefaultProjectTeams_ProjectTechEmployee = Helpers.createClassArray(DefaultProjectTeam, item.DefaultProjectTeams_ProjectTechEmployee);
      this.ItemRateTableNames_Owner = Helpers.createClassArray(ItemRateTableName, item.ItemRateTableNames_Owner);
      this.ProjectEstimates_Creator = Helpers.createClassArray(ProjectEstimate, item.ProjectEstimates_Creator);
      this.ProjectEstimates_RecordApprover = Helpers.createClassArray(ProjectEstimate, item.ProjectEstimates_RecordApprover);
      this.Projects_CreatorUser = Helpers.createClassArray(Project, item.Projects_CreatorUser);
      this.ProjectTemplates_OwnerEmployee = Helpers.createClassArray(ProjectTemplate, item.ProjectTemplates_OwnerEmployee);
    }
  }
}